const ActionTypes = {
    COMPLETE_PROMO_UPLOAD_FAILURE: 'COMPLETE_PROMO_UPLOAD##FAILURE',
    COMPLETE_PROMO_UPLOAD_REQUEST: 'COMPLETE_PROMO_UPLOAD##REQUEST',
    COMPLETE_PROMO_UPLOAD_SUCCESS: 'COMPLETE_PROMO_UPLOAD##SUCCESS',
    PROMO_BRAND_FETCH_FAILURE: 'PROMO_BRAND_FETCH##FAILURE',
    PROMO_BRAND_FETCH_REQUEST: 'PROMO_BRAND_FETCH##REQUEST',
    PROMO_BRAND_FETCH_SUCCESS: 'PROMO_BRAND_FETCH##SUCCESS',
    PROMO_CREATE_FAILURE: 'PROMO_CREATE##FAILURE',
    PROMO_CREATE_REQUEST: 'PROMO_CREATE##REQUEST',
    PROMO_CREATE_SUCCESS: 'PROMO_CREATE##SUCCESS',
    PROMO_DELETE_FAILURE: 'PROMO_DELETE##FAILURE',
    PROMO_DELETE_REQUEST: 'PROMO_DELETE##REQUEST',
    PROMO_DELETE_SUCCESS: 'PROMO_DELETE##SUCCESS',
    PROMO_ID_FETCH_FAILURE: 'PROMO_ID_FETCH##FAILURE',
    PROMO_ID_FETCH_REQUEST: 'PROMO_ID_FETCH##REQUEST',
    PROMO_ID_FETCH_SUCCESS: 'PROMO_ID_FETCH##SUCCESS',
    PROMO_TYPES_FETCH_FAILURE: 'PROMO_TYPES_FETCH##FAILURE',
    PROMO_TYPES_FETCH_REQUEST: 'PROMO_TYPES_FETCH##REQUEST',
    PROMO_TYPES_FETCH_SUCCESS: 'PROMO_TYPES_FETCH##SUCCESS',
    PROMO_UPDATE_FAILURE: 'PROMO_UPDATE##FAILURE',
    PROMO_UPDATE_REQUEST: 'PROMO_UPDATE##REQUEST',
    PROMO_UPDATE_SUCCESS: 'PROMO_UPDATE##SUCCESS',
    PROMOS_FETCH_FAILURE: 'PROMOS_FETCH##FAILURE',
    PROMOS_FETCH_REQUEST: 'PROMOS_FETCH##REQUEST',
    PROMOS_FETCH_SUCCESS: 'PROMOS_FETCH##SUCCESS',
} as const

export default ActionTypes
